/**
 * WindowTitle.js
 * Implements the title context window
 */

import { Game, GameWindow, OptionsMenuMode, UiElement, UiButton } from "pixi_core";

import { Common } from "../game/Common";

import {
    GameEvents,
    MUSIC_FADE_IN_TIME,
    MUSIC_FADE_OUT_TIME,
    OPTIONS_PREFAB,
    CLEAR_COLOR_TITLE,
    GEAR_MENU_Y_POS,
    GEAR_MENU_X_POS,
    SETTINGS_PREFAB
} from "../Constants";

export class WindowTitle extends GameWindow {
    constructor() {
        super({
            name: "WindowTitle",
            isTitleWindow: true
        });

        /** @private @type {UiButton} */
        this._btnPlay = null;
        /** @private @type {UiButton} */
        this._btnPlaySingle = null;
        /** @private @type {UiButton} */
        this._btnReset = null;
    }

    /**
     * The window is opening for the first time
     * @protected
     */
    _onFirstWindowOpening() {
        /** @type {UiElement} */
        const rootPrefebElement = Game.ui.instantiate("Title", this);

        this._btnPlay = rootPrefebElement.findElementByName("BtnPlay");
        this._btnPlaySingle = rootPrefebElement.findElementByName("BtnPlaySingle");
        this._btnReset = rootPrefebElement.findElementByName("BtnReset");

        Game.on(GameEvents.eTITLE_PLAY, this._onBtnPlay, this);
        Game.on(GameEvents.eTITLE_RESET, this._onBtnReset, this);
    }

    /**
     * The window is opening
     * @protected
     */
    _onWindowOpening() {
        // Configure options menu for this context
        Game.windows.optionsMenu.reset({
            prefab: OPTIONS_PREFAB,
            prefabSettings: SETTINGS_PREFAB,
            mode: OptionsMenuMode.eOPTIONS,
            exclude: ["BtnHome", "BtnRestart", "BtnLevelSelection"]
        });

        // Configure gear button for this context
        Game.windows.showGearButton({
            fullScreen: true,
            idSprite: "BTN_Gear",
            idSpriteOver: "BTN_GearHover",
            idSpritePressed: "BTN_GearPressed",
            idSpriteBack: "BTN_Back",
            idSpriteBackOver: "BTN_BackHover",
            idSpriteBackPressed: "BTN_BackPressed",
            scalePressed: 1,
            x: GEAR_MENU_X_POS,
            y: GEAR_MENU_Y_POS
        });

        Game.audio.playMusic("IDSND_MUSIC_MENU", { fadeOutTime: MUSIC_FADE_OUT_TIME, fadeInTime: MUSIC_FADE_IN_TIME });

        this._resetButtons();

        Game.setClearColor(CLEAR_COLOR_TITLE);
    }

    /**
     * @private
     */
    _resetButtons() {
        const haveSaveData = Common.save.haveSaveData();

        this._btnReset.setVisible(haveSaveData);
        this._btnPlay.setVisible(haveSaveData);
        this._btnPlaySingle.setVisible(!haveSaveData);

        this.resetNavigationButtonGroups();
        if (haveSaveData) {
            this.setDefaultNavigationButton(this._btnPlay);
        } else {
            this.setDefaultNavigationButton(this._btnPlaySingle);
        }
    }

    /**
     * The window is closed
     * @protected
     */
    _onWindowClosed() {}

    /**
     * The play button has been tapped
     * @private
     */
    _onBtnPlay() {
        Game.windows.changeContext("WindowLevelSelection");
        Game.audio.playSfx("IDSND_PLAY_BUTTON");
    }

    /**
     * @private
     */
    _onBtnReset() {
        Game.windows.messageBox.open({
            message: Game.localization.getText("IDS_TXT_NEW_GAME_QUESTION") + "\n" + Game.localization.getText("IDS_MSGBOX_SAVE_LOSE"),
            onConfirm: this._onResetConfirm.bind(this)
        });
    }

    /**
     * @private
     */
    _onResetConfirm() {
        Game.fire(GameEvents.eTUTORIAL_RESET_STEPS);
        Game.save.clearGameData();
        Game.windows.changeContext("WindowLevelSelection");
    }
}
